import { Inject, Injectable } from '@angular/core';
import { SEGMENT_REPOSITORY, SegmentsRepository } from '@core/repositories/segments.repository';
import { Segment } from '@shared/interfaces/segment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SegmentsService {
  constructor(
    @Inject(SEGMENT_REPOSITORY) protected repository: SegmentsRepository
  ) {}

  getItems(): Observable<any> {
    return this.repository.getItems();
  }

  add(segment: Segment): Observable<any> {
    return this.repository.add(segment);
  }

  edit(segment: Segment): Observable<any> {
    return this.repository.edit(segment);
  }

  delete(item: any): Observable<any> {
    return this.repository.delete(item);
  }
}
